import { firebase } from '@firebase/app';
import '@firebase/auth'
import '@firebase/database';

var firebaseConfig = {
	apiKey: 'AIzaSyDW5yzvXQxBhxsV8ohxjTuIM06oFiuXAhk',
	authDomain: 'rigi-windegg.firebaseapp.com',
	databaseURL: 'https://rigi-windegg.firebaseio.com',
	projectId: 'rigi-windegg',
	storageBucket: 'rigi-windegg.appspot.com',
	messagingSenderId: '119870875529'
};

firebase.initializeApp(firebaseConfig);
export default firebase;